import randomColor from 'randomcolor'

let randomColors

const generateColors = () => randomColor({
  count: 200,
  luminosity: 'bright',
})

try {
  if (localStorage) {
    if (localStorage.getItem('randomcolors')) {
      randomColors = JSON.parse(localStorage.getItem('randomcolors'))
    } else {
      randomColors = generateColors()
      localStorage.setItem('randomcolors', JSON.stringify(randomColors))
    }
  } else {
    randomColors = generateColors()
  }
} catch (e) {
  randomColors = generateColors()
}

const colors = [
  ...randomColors,
  '#9B9A9A', '#F4F4F5', '#7A7A7A', '#157FFB', '#BDE0FC', '#71D327', '#70CD7C',
  '#771BA9', '#FF6523', '#9eb9d0', '#42D8B8', '#F7B700', '#E01A1A',
]

export const getColors = (preparationSteps, cookingSteps, initialSteps, finalSteps) => {
  const usedColors = [...colors]
  const result = {}
  const steps = [...preparationSteps, ...cookingSteps, ...initialSteps, ...finalSteps]
  steps.forEach(step => {
    const ref1 = step.stepJump1NewKey ||  step.stepJump1ID
    if (ref1) {
      if (!result[ref1]) {
        result[ref1] = usedColors.pop()
      }
    }
    const ref2 = step.stepJump2NewKey ||  step.stepJump2ID
    if (ref2) {
      if (!result[ref2]) {
        result[ref2] = usedColors.pop()
      }
    }
  })
  return result
}

export const hasRefTo = (step, colors) => {
  return step && (colors[step.stepNewKey] || colors[step.stepID])
}

export const hasRef1From = (step, colors) => {
  return step && (colors[step.stepJump1NewKey] || colors[step.stepJump1ID])
}

export const hasRef2From = (step, colors) => {
  return step && (colors[step.stepJump2NewKey] || colors[step.stepJump2ID])
}
